import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 1,
    connected: false,
    error: "",
    message: "",
    newWData: "",
    socketMessages: [],
    channelMessages: [],
    nspChannelMessages: [],
    wData: [],
    sensorReadings: [],
    sensors: [],
    updatedTime: ""
  },
  /*
  Vuex constructs Observables from all your state properties, 
  so you will need to think differently here. Try to build a getter
  with an argument so you can return a value
  */
  getters: {
    doubleup(state) {
      return state.count * 2;
    },
    get_sensorReadings: state => {
      if (state.sensorReadings.length) return state.sensorReadings;
    },
    get_wData: state => {
      if (state.wData.length) return state.wData;
    },
    get_sensors: state => {
      if (state.sensors.length) return state.sensors;
    },
    get_updatedTime: state => {
      return state.updatedTime;
    },
    get_socketConnectionStatus: state => {
      return state.connected;
    }
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    set_sensorReadings(state, readings) {
      state.sensorReadings = readings;
    },
    set_counter(state, newCount) {
      state.count = newCount;
    },
    set_wData(state, data) {
      state.wData = data;
    },
    socketOnConnect(state) {
      state.socketMessages.unshift({
        msg: "socket connected",
        date: Date.now()
      });
      state.connected = true;
    },
    socketOnDisconnect(state) {
      state.socketMessages.push("socket disconnected");
      state.connected = false;
    },
    pushMessageToSocketMessages(state, message) {
      // state.socketMessages.push(message);
      state.socketMessages.unshift(message);
    },
    socketOnMessage(state, message) {
      state.channelMessages.push(message);
    },
    sensorReading(state, data) {
      // console.log("✨✨✨ getting updated sensor readings....");
      state.sensorReadings.forEach((r, i) => {
        // console.log(r);
        if (r.deviceId == data.deviceId) {
          // state.sensorReadings[i] = data;
          Vue.set(state.sensorReadings, i, data);
          // we use the above to maintain reactivity. Vue cannot track normal array operations
          // that change the length or the value of an item without using .set().
          state.socketMessages.unshift({
            date: Date.now(),
            sensorName: data.sensorName,
            sensorType: data.sensorType
          });
          state.updatedTime = data.timestamp;
        }
      });
    },
    setSocketConnectionStatus(state, data) {
      state.connected = data;
    }
  },
  actions: {
    reset_counter(context) {
      context.commit("set_counter", 0);
    },
    sendUpdatedWData: ({ commit }, newVals) => {
      commit("set_wData", newVals);
    },
    populateInitialSensorReadings: async ({ commit, state }) => {
      //iterate wdata and take latest reading for each sensor
      // sort array of obj by datetime
      let readings = [];
      // console.log("getters.get_wData", getters.get_wData);
      // let d = getters.wData;
      // console.log("d", d);
      // console.log("wData", wData);
      // console.log(getters["get_wDataVals"]);
      let dateSorted = state.wData.sort(function(a, b) {
        // let dateSorted = wData.sort(function(a, b) {
        return (
          new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
        );
      });

      // console.log("dateSorted", dateSorted);

      function doLoop() {
        state.sensors.forEach(s => {
          // console.log("sensor", s);
          for (let i = 0; i < dateSorted.length; i++) {
            // console.log("dateSorted[i].deviceId", dateSorted[i].deviceId);
            // console.log("s.deviceId", s.deviceId);

            if (dateSorted[i].deviceId == s.deviceId) {
              readings.push(dateSorted[i]);
              // take the first reading for this sensor and break
              break;
            }
          }
        });
      }

      await doLoop();
      // console.log("readings", readings);
      // console.log("sensors", state.sensors);

      commit("set_sensorReadings", readings);
      return;
    }
  }
});
